import { PortalModule } from "@angular/cdk/portal";
import { AsyncPipe, NgIf } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { NiceBreadcrumbComponent } from "@recursyve/ngx-panko";
import {
    NiceLayoutModule,
    NiceLoadingSpinnerModule,
    NiceNavigationModule,
    ResolveDirective
} from "@recursyve/nice-ui-kit.v2";
import { CitizenIntroductionModule } from "./citizen-introduction/citizen-introduction.module";
import { NavbarModule } from "./components/navbar/navbar.module";
import { DashboardComponent } from "./dashboard.component";
import { DashboardQuery } from "./store/dashboard.query";
import { DashboardService } from "./store/dashboard.service";
import { DashboardStore } from "./store/dashboard.store";
import { CitizenNavbarComponent } from "./components/citizen-navbar/citizen-navbar.component";

@NgModule({
    imports: [
        NiceLayoutModule,
        NiceNavigationModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        NavbarModule,
        NiceBreadcrumbComponent,
        NiceLoadingSpinnerModule,
        CitizenIntroductionModule,
        AsyncPipe,
        NgIf,
        PortalModule,
        ResolveDirective,
        CitizenNavbarComponent
    ],
    declarations: [DashboardComponent],
    providers: [DashboardQuery, DashboardService, DashboardStore]
})
export class DashboardModule {}
